import { useCallback, useEffect, useRef, useState } from "react";

function resolvePanelBound(bound) {
  return typeof bound === "function" ? bound() : bound;
}

export function useResizablePanel(defaultWidth, min, max, direction = 1) {
  const [width, setWidth] = useState(defaultWidth);
  const dragging = useRef(false);
  const startX = useRef(0);
  const startW = useRef(0);
  const removeListenersRef = useRef(null);

  useEffect(() => () => removeListenersRef.current?.(), []);

  const onMouseDown = useCallback(
    (event) => {
      event.preventDefault();
      removeListenersRef.current?.();
      dragging.current = true;
      startX.current = event.clientX;
      startW.current = width;

      const onMouseMove = (moveEvent) => {
        if (!dragging.current) return;
        const delta = (moveEvent.clientX - startX.current) * direction;
        setWidth(
          Math.min(
            resolvePanelBound(max),
            Math.max(resolvePanelBound(min), startW.current + delta)
          )
        );
      };

      const onMouseUp = () => {
        dragging.current = false;
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
        document.body.style.cursor = "";
        document.body.style.userSelect = "";
        removeListenersRef.current = null;
      };

      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
      document.body.style.cursor = "col-resize";
      document.body.style.userSelect = "none";
      removeListenersRef.current = onMouseUp;
    },
    [direction, max, min, width]
  );

  return [width, onMouseDown, setWidth];
}

export function useResizableRightPanel(defaultWidth, min, max) {
  return useResizablePanel(defaultWidth, min, max, -1);
}
